import { observable } from 'mobx';
import type { OrderItemStepStatusEnum } from './order_item_step_status';
import type { MasterOrderItemActionArgs } from '../master_step/master_order_item_action';
import type { OrderItemStatus } from './order_item_status';
import type { OrderItemStepTimeResponseArgs } from './order_item_step_time';
import OrderItemStepTime, { convertOrderItemStepTimeResponseToArgs } from './order_item_step_time';

export interface OrderItemStepResponseArgs {
  id?: number;
  master_step_id: number;
  status: OrderItemStepStatusEnum;
  step_num: number;
  step_name?: string;
  step_code?: string;
  step_description?: string;
  step_document_url?: string;
  master_order_item_actions?: MasterOrderItemActionArgs[];
  order_item_step_times?: OrderItemStepTimeResponseArgs[];
  finished_status: keyof typeof OrderItemStatus;
  target_status: keyof typeof OrderItemStatus;
}

export interface OrderItemStepArgs {
  id?: number;
  masterStepId: number;
  status: OrderItemStepStatusEnum;
  stepNum: number;
  stepName?: string;
  stepCode?: string;
  stepDescription?: string;
  stepDocumentUrl?: string;
  orderItemStepTimes?: OrderItemStepTime[];
  finishedStatus: keyof typeof OrderItemStatus;
  targetStatus: keyof typeof OrderItemStatus;
}

export const convertOrderItemStepResponseToArgs = (response: OrderItemStepResponseArgs) => {
  const args: OrderItemStepArgs = {
    id: response.id,
    masterStepId: response.master_step_id,
    status: response.status,
    stepNum: response.step_num,
    stepName: response.step_name,
    stepCode: response.step_code,
    stepDescription: response.step_description,
    stepDocumentUrl: response.step_document_url,
    orderItemStepTimes: response.order_item_step_times?.map(
      time => new OrderItemStepTime(convertOrderItemStepTimeResponseToArgs(time))
    ),
    finishedStatus: response.finished_status,
    targetStatus: response.target_status
  };
  return args;
};

export default class OrderItemStep {
  @observable readonly id?: number;
  @observable readonly masterStepId: number;
  @observable readonly status: OrderItemStepStatusEnum;
  @observable readonly stepNum: number;
  @observable readonly stepName?: string;
  @observable readonly stepCode?: string;
  @observable readonly stepDescription?: string;
  @observable readonly stepDocumentUrl?: string;
  @observable readonly orderItemStepTimes?: OrderItemStepTime[];
  @observable readonly finishedStatus: keyof typeof OrderItemStatus;
  @observable readonly targetStatus: keyof typeof OrderItemStatus;

  constructor(args: OrderItemStepArgs) {
    this.id = args.id;
    this.masterStepId = args.masterStepId;
    this.status = args.status;
    this.stepNum = args.stepNum;
    this.stepName = args.stepName;
    this.stepCode = args.stepCode;
    this.stepDescription = args.stepDescription;
    this.stepDocumentUrl = args.stepDocumentUrl;
    this.orderItemStepTimes = args.orderItemStepTimes;
    this.finishedStatus = args.finishedStatus;
    this.targetStatus = args.targetStatus;
  }
}
